import I18n from 'I18n';
import PortalIdParser from 'PortalIdParser';
import { STATUS } from 'framework-asset-preview-lib/internal/shared/constants/assetPreview';
import { getPropertyValue } from 'framework-asset-preview-lib/internal/shared/utils/crmObject';
export const AD_NETWORK_TYPE = {
  FACEBOOK: 'FACEBOOK',
  GOOGLE: 'GOOGLE',
  LINKEDIN: 'LINKEDIN'
};
export function getNonCrmPropertyValue(propertyName, nonCrmObject) {
  if (!nonCrmObject) {
    return undefined;
  }
  const adCampaignResponse = nonCrmObject;
  switch (propertyName) {
    default:
      return undefined;
    case 'type':
      return adCampaignResponse.adCampaignDetails.entity.type;
    case 'accountName':
    case 'accountCreatedById':
      {
        const adAccountId = adCampaignResponse.adCampaignDetails.entity.accountId;
        const adAccount = adCampaignResponse.adAccounts.accounts.find(account => account.accountId === adAccountId);
        if (!adAccount) {
          return undefined;
        }
        if (propertyName === 'accountName') {
          return adAccount.accountName;
        }
        return adAccount.primaryHubSpotUserId;
      }
  }
}
export function getAdCampaignStatus(status, startDate, endDate) {
  const currentTimestamp = Date.now();
  const hasCompleted = endDate && endDate < currentTimestamp;
  const hasStarted = startDate < currentTimestamp;
  if (status === STATUS.ENABLED) {
    if (hasCompleted) {
      return STATUS.COMPLETED;
    }
    if (hasStarted) {
      return STATUS.ACTIVE;
    }
    return STATUS.SCHEDULED;
  }
  if (status === STATUS.PAUSED) {
    if (hasCompleted) {
      return STATUS.COMPLETED;
    }
    if (hasStarted) {
      return STATUS.PAUSED;
    }
    return STATUS.SCHEDULED;
  }
  return status === STATUS.ARCHIVED ? STATUS.DELETED : status;
}

/**
 * From https://git.hubteam.com/HubSpot/AdsFrontend/blob/3d4899e26aa56d79f7fa806c93102df77125900f/AdsUI/static/js/records/ad-management/AdWordsTargetingRecord.js#L18-L35
 */
function getAdWordName(response) {
  if (response.audience) {
    return response.audience.name;
  } else if (response.carrier) {
    return response.carrier.name;
  } else if (response.geoLocation) {
    return response.geoLocation.name;
  } else if (response.language) {
    return response.language.name;
  } else if (response.mobileAppCategory) {
    return response.mobileAppCategory.name;
  } else if (response.operatingSystemVersion) {
    return response.operatingSystemVersion.name;
  } else if (response.topic) {
    return response.topic.name;
  } else if (response.campaignCriterion.device) {
    return I18n.text(`frameworkAssetPreviewLib.propertyValue.0-31.devices.${response.campaignCriterion.device.type}`);
  }
  return '';
}
function addAdWordNameByCampaignCriterion(result, ad) {
  const adWordName = getAdWordName(ad);
  if (!adWordName) {
    return result;
  }
  if (!(ad.campaignCriterion.type in result)) {
    result[ad.campaignCriterion.type] = [];
  }
  result[ad.campaignCriterion.type].push(adWordName);
  return result;
}

/**
 * Use only enabled entries and split response into "inclusions" and "exclusions" as per
 * https://git.hubteam.com/HubSpot/AdsFrontend/blob/3d4899e26aa56d79f7fa806c93102df77125900f/AdsUI/static/js/records/ad-management/AdWordsTargetingRecord.js#L66-L71
 */
export function formatAdCampaignTargeting(adCampaignTargetingResponse) {
  const enabledTargetingResponse = adCampaignTargetingResponse.filter(data => data.campaignCriterion.status === 'ENABLED');
  return {
    inclusions: enabledTargetingResponse.filter(ad => !ad.campaignCriterion.negative).reduce(addAdWordNameByCampaignCriterion, {}),
    exclusions: enabledTargetingResponse.filter(ad => ad.campaignCriterion.negative).reduce(addAdWordNameByCampaignCriterion, {})
  };
}
export function getNetworkNameForApiCall(crmObject) {
  const hsAdNetwork = getPropertyValue(crmObject, 'hs_ad_network');
  switch (hsAdNetwork) {
    default:
    case AD_NETWORK_TYPE.FACEBOOK:
      return 'facebook';
    case AD_NETWORK_TYPE.GOOGLE:
      return 'adwords';
    case AD_NETWORK_TYPE.LINKEDIN:
      return 'linkedin';
  }
}
export function isAdAccountAuthError(error) {
  var _error$responseJSON;
  return ((_error$responseJSON = error.responseJSON) === null || _error$responseJSON === void 0 ? void 0 : _error$responseJSON.errorType) === 'AUTH' || error.errorType === 'AUTH';
}
export const adCampaignErrorHandler = error => {
  if (!isAdAccountAuthError(error)) {
    return null;
  }
  return {
    errorType: 'AD_ACCOUNT_AUTH_ERROR',
    messageKey: 'frameworkAssetPreviewLib.error.adAccountAuthError',
    buttonTextKey: 'frameworkAssetPreviewLib.error.adAccountAuthErrorButton',
    buttonHref: `/settings/${PortalIdParser.get()}/marketing/ads/adAccounts`
  };
};